module.exports = "<div class=\"side-app hidden-xs\" [ngClass]=\"isLastStep ? lastStepName : ''\">\n  <router-outlet name=\"side\"></router-outlet>\n</div>\n"